import React from 'react';
import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { backendUrl } from '../../../lib/config';
import RaisedButton from 'material-ui/RaisedButton';
import { CircularProgress } from 'material-ui';

export const FileUploader = memo(props => {
	const { label = 'ЗАГРУЗИТЬ ФАЙЛ', filename, extension = 'txt' } = props;
	const [isLoading, setIsLoading] = useState(false);
	const [fileExist, setFileExist] = useState(false);

	const fileUrl = useMemo(() => {
		return `${backendUrl}/doc_file?filename=${filename}&extension=${extension}`;
	}, [filename, extension]);

	useEffect(() => {
		async function load() {
			const response = await fetch(fileUrl);
			const status = response.status;
			if (status === 200) {
				setFileExist(true);
			}
		}

		load().catch();
	}, [fileUrl]);

	const handleUpload = useCallback(event => {
		async function upload() {
			const file = event.target.files[0];
			const formData = new FormData();
			formData.append('file', file);
			setIsLoading(true);
			await fetch(`${backendUrl}/upload_doc_file`, {
				method: 'POST',
				body: formData,
			});
		}

		upload()
			.catch()
			.finally(() => {
				setIsLoading(false);
				setFileExist(true);
			});
	}, []);

	return (
		<div className="uploader">
			{isLoading ? (
				<div>
					<CircularProgress size={20} disableShrink={true} />
					<span>ИДЕТ ЗАГРУЗКА</span>
				</div>
			) : (
				<p>
					<RaisedButton containerElement="label" disabled={isLoading} label={label}>
						<input type="file" style={{ display: 'none' }} onChange={handleUpload} />
					</RaisedButton>
					<br />
					{fileExist && (
						<p>
							<a href={fileUrl} target="_blank">
								{`Текущая версия ${filename}.${extension}`}
							</a>
						</p>
					)}
				</p>
			)}
		</div>
	);
});



// WEBPACK FOOTER //
// src/components/ui/file-uploader/file-uploader.jsx